module.exports = __webpack_public_path__ + "img/google-play-badge-2018.f05e074.svg";